import { CoeditingEntityOutline } from "./CoeditingEntityOutline";

export const CoeditingNarratorStepOutline = ({ id }: { id: string }) => {
  return (
    <div className="combo-narrator__step-options-container tw-relative">
      <div className="tw-sticky tw-top-[calc(var(--narrator-top-offset)_+_var(--narrator-step-outline-padding-y))] tw-z-10 tw-m-[var(--narrator-step-outline-padding-y)_auto] tw-h-[var(--narrator-step-outline-height)] tw-w-[calc(100%_-_var(--narrator-step-outline-padding-x)_*_2)]">
        <CoeditingEntityOutline id={id} name="narrator-step" />
      </div>
    </div>
  );
};
